import {Api} from '@/core/api.js';
const api = new Api();

// initial state
const state = {
  list: [],
}

// getters
const getters = {
  
}

// actions
const actions = {

    uploadNote( { commit }, note ){
        var path = ( typeof note.id !== 'undefined' )? 'note/' + note.id + '/update' : 'note/add';
        return api.post( path, note ).then( function( response ){
           return response;
        });
    },

    removeNote( { commit }, id ){
        return api.get( 'note/' + id + '/remove' ).then( function( response ){
            if( response.status ){
                return response;
            }
        });
    }

  
}

// mutations
const mutations = {

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}